import { useState, useMemo } from 'react';
import { flowType } from '@utility/userInfo';
import { getObjectValue } from '@utility/utills';
import { APP_CONFIG } from '@constants';
import { getFilteredOutModifiersFromParentItem } from '../utils';
import { safeJsonParse } from '@utility/helperFunction';
import getDeviceType from '@utility/deviceType';

export const useOrderMenuTop = props => {
  const [loader, setLoader] = useState(false);
  const [cancelOrderConfirm, setCancelOrderConfirm] = useState(false);
  const flowTypeValue = useMemo(() => flowType(), []);
  const {
    isServerApp,
    isTableTop,
    isWalkUp,
    isTogo,
    isSpeedOrderMode: speedOrderMode,
    isCounter,
    // isOrderPayMode
  } = getDeviceType();

  const isDefaultMode = useMemo(
    () =>
      getObjectValue(
        () =>
          !isWalkUp &&
          !isTogo &&
          !speedOrderMode &&
          (!props.deviceInfo.deviceGroup ||
            [0].includes(props.deviceInfo.deviceGroup.startMode)),
        false
      ),
    [isWalkUp, isTogo, props.deviceInfo]
  );
  const isOrderPayMode = useMemo(
    () =>
      getObjectValue(
        () =>
          flowTypeValue === 'tableTop' &&
          [1].includes(props.deviceInfo?.deviceGroup?.startMode),
        false
      ),
    [flowTypeValue, props.deviceInfo]
  );

  const addInProcessItemsToCart = cb => {
    const inProcessItem = props.cart.filter(e => e.isProcessing);
    setLoader(true);
    const dataToSendToAdd = {
      storeId: props.deviceInfo?.storeId,
      deviceId: props.deviceInfo?.deviceId,
      employeeId: Number(props.userInfo?.id),
      employeeCard: props.userInfo?.employeeCard,
      checkHeaderId: props.check?.id,
      stationId: props.check?.stationId,
      items: inProcessItem,
      orderJson: JSON.stringify([...inProcessItem]),
      longitude: '0',
      latitude: '0',
      geoLocation: '0',
    };
    if (inProcessItem?.length > 0) {
      props.addChecks(dataToSendToAdd, 'add').then(res => {
        props.updateSeatInfo(res);
        const ItemsArray = res.orders[0]?.items || [];
        if (ItemsArray?.length > 0) {
          const CartItems = [];
          ItemsArray.forEach(item => {
            if (item.pending && item.itemType !== 'D') {
              const cartData = {
                ...safeJsonParse(safeJsonParse(item?.orderJson, {})?.modifierJson, {}),
                isProcessing: false,
                modifierJson: safeJsonParse(item?.orderJson, {})?.modifierJson,
                id: item.id,
                checkItemId: item.checkItemId,
              };
              CartItems.push(cartData);
            }
          });
          props.replaceCart(CartItems);
          setLoader(false);
          const filteredCart = getFilteredOutModifiersFromParentItem(CartItems);
          if (cb) cb(filteredCart, res);
        }
      });
    } else {
      setLoader(false);
      const filteredCart = getFilteredOutModifiersFromParentItem(props.cart);
      if (cb) cb(filteredCart, props.check);
    }
  };

  const cancelForCounter = () => setCancelOrderConfirm(true);

  const handleClose = () => {
    const type =
      !props.deviceInfo?.deviceGroup?.inputFields?.nameEnabled &&
      !props.deviceInfo?.deviceGroup?.inputFields?.phoneNumberEnabled;
    const dataToSend = {
      employeeId: Number(props?.userInfo?.id),
      storeId: props?.deviceInfo?.storeId,
      checkHeaderId: props?.check?.id,
      deviceId: props?.deviceInfo?.deviceId,
    };
    props
      .checkVoid(dataToSend)
      .then(res => {
        props.clearCart();
        props.updateChecksAfterResponse(res).then(() => {
          if (props?.deviceInfo?.deviceGroup?.startMode === 2) {
            props.history.push({ pathname: `${APP_CONFIG.BASE_URL}/callCenterError` });
          } else {
            props.history.replace({
              pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/checks`,
              state: { type: type ? 'checks' : 'order' },
            });
          }
        });
      })
      .catch(e => props.setErrorPopUp({ res: e.message }));
  };

  const goToChecks = () => {
    setCancelOrderConfirm(false);
    if (isCounter || isOrderPayMode) {
      addInProcessItemsToCart(() => handleClose());
    } else if (isWalkUp) {
      handleClose();
    } else if (props?.deviceInfo?.deviceGroup?.startMode === 2) {
      handleClose();
    } else {
      props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/checks` });
    }
  };

  return {
    loader,
    cancelOrderConfirm,
    setCancelOrderConfirm,
    isServerApp,
    isTableTop,
    isWalkUp,
    isTogo,
    speedOrderMode,
    isDefaultMode,
    isCounter,
    isOrderPayMode,
    addInProcessItemsToCart,
    cancelForCounter,
    handleClose,
    goToChecks,
  };
};
